import { render, staticRenderFns } from "./Logodia.vue?vue&type=template&id=dfc67846&scoped=true&"
import script from "./Logodia.vue?vue&type=script&lang=js&"
export * from "./Logodia.vue?vue&type=script&lang=js&"
import style0 from "./Logodia.vue?vue&type=style&index=0&id=dfc67846&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc67846",
  null
  
)

export default component.exports